import toast, { ToastOptions } from 'react-hot-toast';
import { getErrorMessage } from '../api/client';

const errorStyle: ToastOptions = {
  duration: 5500,
  style: {
    fontSize: '14px',
    maxWidth: '420px',
    borderLeft: '4px solid #ef4444',
    background: '#fff',
    color: '#111827',
  },
};

const successStyle: ToastOptions = {
  duration: 4000,
  style: {
    fontSize: '14px',
    maxWidth: '420px',
    borderLeft: '4px solid #4f46e5',
    background: '#fff',
    color: '#111827',
  },
};

const infoStyle: ToastOptions = {
  duration: 4000,
  style: {
    fontSize: '14px',
    maxWidth: '420px',
    borderLeft: '4px solid #64748b',
    background: '#fff',
    color: '#111827',
  },
};

export function notifyError(error: unknown, fallback?: string) {
  toast.error(getErrorMessage(error, fallback ?? 'Something went wrong.'), errorStyle);
}

export function notifyErrorMessage(message: string) {
  toast.error(message, errorStyle);
}

export function notifySuccess(message: string) {
  toast.success(message, successStyle);
}

export function notifyInfo(message: string) {
  toast(message, { ...infoStyle, icon: 'ℹ️' });
}
